import type { Ref } from 'vue'
import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { unref } from 'vue'
import { getApi } from './api'

export interface GetAccountPaymentsParams {
  /** Filter by owner: 'all' (default), 'order', or 'commitment'. */
  owner?: 'all' | 'order' | 'commitment'
  page?: number
  per_page?: number
  [key: string]: unknown
}

export default (
  accountId: Ref<number> | number,
  params?: Ref<GetAccountPaymentsParams> | GetAccountPaymentsParams,
) => {
  return useQuery({
    queryKey: ['account-payments', () => unref(accountId), () => unref(params)],
    queryFn: async () => {
      const { api, baseURL } = getApi()
      const res = await api.get(`/api/v2/accounts/${unref(accountId)}/payments`, {
        baseURL,
        params: unref(params),
      })
      return res.data
    },
    placeholderData: keepPreviousData,
    enabled: () => !!unref(accountId),
  })
}
